<template>
<!--  完工验收-->
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-collapse-item title="基本信息" name="1">
      <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.houseName" label="房号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.decorateTypeName" label="装修方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.decorateStartDate" label="装修开始日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.acceptanceDate" label="完工验收日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.recodeDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.applicantName" label="装修申请人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.applicantPhone" label="联系电话" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.entryDoorRenovationName" label="进户门有无改造" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.waterPipeRenovationName" label="共用落水管道是否改造" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.waterPipeRenovationRequirement" label="共用落水管道私自改造整改要求" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.acceptanceResult" label="验收结果" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="业主户内防水验收登记表" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
        <template #input>
          <div @click="view" style="color: #4caedc">查看详情</div>
        </template>
      </van-field>
<!--      <van-field label="公共部位施工审批单" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
      <div style="padding-left: 16px;" v-show="inputForm.constructionAttachList.length > 0">
        <p>公共部位施工审批单</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.constructionAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
<!--      <div style="padding-left: 16px;">-->
<!--        <p>公共部位施工审批单</p>-->
<!--        <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.constructionAttachList" :href="file.url">{{file.name}}</a>-->
<!--        <div class="m-row" v-if="inputForm.constructionAttachList.length==0">无</div>-->
<!--      </div>-->
      <van-field v-model="inputForm.isDeduction" label="是否扣款" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" >
        <template #input>
          <div v-if="inputForm.isDeduction=='1'">是</div>
          <div v-else>否</div>
        </template>
      </van-field>
      <van-field v-if="inputForm.isDeduction=='1'" v-model="inputForm.deductionAmount" label="扣款金额(元)" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.isDeduction=='1'" v-model="inputForm.feeNormName" label="扣款对应的收费标准" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-if="inputForm.isDeduction=='1'" v-model="inputForm.deductionDate" label="应扣款日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field label="验收结果附件" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea">
      </van-field>
      <div style="display: flex; padding-left: 16px">
        <van-image v-for="(item, index) in inputForm.acceptanceResultAttachList" :key="item.id" width="100px" height="100px" fit="cover" :src="item.url" @click="preview(inputForm.acceptanceResultAttachList, index)" />
      </div>

    </van-collapse-item>
  </van-collapse>

  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import {ImagePreview} from "vant";
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "decorateAcceptance",
  data(){
    return {
      activeNames: ['1'],
      isshow: false,
      radio: '',
      inputForm: {
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/decorate/wuyeDecorateInfoAcceptance/queryById').then(({ data }) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(_this.inputForm, '/decorate/wuyeDecorateInfoAcceptance/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/decorate/wuyeDecorateInfoAcceptance/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    preview(arr, index){
      ImagePreview({
        images: arr.map(item => item.url),
        startPosition: index
      })
    },
    view(){
      this.$router.push({
        path: '/wuye_decorate_info_waterproof_acceptance_view',
        query: {
          id: this.inputForm.waterproofAcceptanceId
        }
      })
    }
  }
}
</script>

<style scoped>

</style>